"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M15.61 7.41 14.2 6l-6 6 6 6 1.41-1.41L11.03 12z"
}), 'NavigateBeforeOutlined');